import type { RouteRecordRaw } from 'vue-router'

import type { AccessLevel } from '@/types/auth.types'

/**
 * Comms + utility routes (§24 TODO board e Link utili, §12 script
 * share). OWNER: fe-comms (Phase 2).
 *
 * The §9 Gmail/Calendar hub and the in-app outreach-email composer were
 * removed — outreach happens directly in Gmail, out of app, confirmed
 * from the agenda funnel's workflow stepper (AgendaWorkflowView), not here.
 *
 * Registered ONCE in `router/index.ts` by fe-nav. fe-comms adds new
 * comms/utility routes here (e.g. a public script-share route, if the
 * §12 share link lands FE-side) — never in index.ts or pms.routes.ts.
 * Catch-all stays library-owned in index.ts; never declare one here.
 */
const STAFF: AccessLevel[] = ['access_level.admin', 'access_level.manager']

export const commsRoutes: RouteRecordRaw[] = [
  {
    path: '/pms/todo',
    name: 'pms-todo',
    component: () => import('@/views/pms/utility/TodoBoardView.vue'),
    meta: { access_levels: STAFF },
  },
  {
    path: '/pms/useful-links',
    name: 'pms-useful-links',
    component: () => import('@/views/pms/utility/UsefulLinksView.vue'),
    meta: { access_levels: STAFF },
  },
  {
    path: '/pms/reach-tool',
    name: 'pms-reach-tool',
    component: () => import('@/views/pms/utility/ReachToolView.vue'),
    meta: { access_levels: STAFF },
  },
  {
    // §12 external script share — the BE mints
    // `{FRONTEND_URL}/scripts/shared/{token}`; the token IS the
    // credential (no JWT). Public per the nav-report note; the
    // catch-all stays in index.ts and remains LAST.
    path: '/scripts/shared/:token',
    name: 'script-shared',
    component: () => import('@/views/pms/comms/SharedScriptView.vue'),
    meta: { public: true },
  },
]
